import { Box, Typography } from "@mui/material";
import FormattedCurrency from "components/WhenBenefit/FormattedCurrency";

interface BenefitProgressCircleProps {
  value: number;
  total: number;
  color?: string;
}

  /* eslint-disable react/prop-types */
const BenefitProgressCircle: React.FC<BenefitProgressCircleProps> = ({ value, total, color = "#2A876C" }) => {
  const size = 230;
  const thickness = 15;
  const percentage = Math.min(100, Math.max(0, (value / total) * 100));
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="transparent" stroke="#f5f5f5" strokeWidth={thickness} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke={color}
          strokeWidth={thickness}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          strokeLinecap="round"
        />
      </svg>
      <Box sx={{ position: "absolute", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", color }}>
          <FormattedCurrency value={value} />
        </Typography>
        <Typography variant="body2" color="text.secondary">
          remaining of <FormattedCurrency value={total} />
        </Typography>
      </Box>
    </Box>
  );
};

export default BenefitProgressCircle;
